const PodcastsSlider = (target) => {
  const initSlider = ($el, params) => {
    $el.slick(params);
  };
  $('body').find(target)
    .each((_, el) => {
      const $el = $(el);
      const params = {
        slidesToShow: 1.1,
        variableWidth: true,
        arrows: false,
        dots: true,
        infinite: false,
        responsive: [
          {
            breakpoint: 99999,
            settings: 'unslick',
          },
          {
            breakpoint: 1280,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1.1,
            },
          },
        ],
      }
      initSlider($el, params);

      $(window).on('resize', () => {
        if (!$el.hasClass('slick-initialized')) {
          initSlider($el, params)
        }
      });
    });
}

export default PodcastsSlider;



// WEBPACK FOOTER //
// ./scripts/components/PodcastsSlider.js